import { CheckCircle2, XCircle } from "lucide-react";

const rows = [
  { feature: "GAF Master Elite Certified", safeway: true, cheap: false },
  { feature: "Lifetime Warranty", safeway: true, cheap: false },
  { feature: "Licensed & Insured", safeway: true, cheap: "Maybe" },
  { feature: "Drone Roof Inspection", safeway: true, cheap: false },
  { feature: "Written Detailed Proposal", safeway: true, cheap: false },
  { feature: "Manufacturer-Backed Warranty", safeway: true, cheap: false },
  { feature: "Background-Checked Crews", safeway: true, cheap: false },
  { feature: "Post-Install Follow-Up", safeway: true, cheap: false },
];

export const AdsVsCheapRoofers = () => (
  <section className="py-16 bg-background">
    <div className="container mx-auto px-4 max-w-3xl">
      <h2 className="text-2xl md:text-3xl font-extrabold text-foreground text-center mb-10">
        <span className="text-primary">Safeway</span> vs. Cheap Roofers
      </h2>
      <div className="rounded-xl border overflow-hidden shadow-sm">
        {/* Header */}
        <div className="grid grid-cols-3 bg-primary text-primary-foreground text-sm font-bold">
          <div className="p-3 md:p-4">Feature</div>
          <div className="p-3 md:p-4 text-center">Safeway</div>
          <div className="p-3 md:p-4 text-center">Others</div>
        </div>
        {/* Rows */}
        {rows.map(({ feature, safeway, cheap }, i) => (
          <div key={feature} className={`grid grid-cols-3 text-sm ${i % 2 === 0 ? "bg-card" : "bg-muted/30"}`}>
            <div className="p-3 md:p-4 font-medium text-foreground">{feature}</div>
            <div className="p-3 md:p-4 flex justify-center">
              {safeway ? <CheckCircle2 className="w-5 h-5 text-green-600" /> : <XCircle className="w-5 h-5 text-destructive" />}
            </div>
            <div className="p-3 md:p-4 flex justify-center items-center">
              {cheap === true ? (
                <CheckCircle2 className="w-5 h-5 text-green-600" />
              ) : cheap === false ? (
                <XCircle className="w-5 h-5 text-destructive" />
              ) : (
                <span className="text-xs text-muted-foreground">{cheap}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
